export default {
  totalBed: ' ظرفیت خالی بستری کووید تا ',
  totalFreeICU: 'مجموع ICU خالی',
  totalOutpatient: 'ظرفیت سرپایی استان',
  totalOutpatientInShift: 'ظرفیت  خدمات سرپایی بیمارستانی کووید در هر شیفت ',
  descriptionOutpatient:
    'میزان تخت خالی در شیفت‌‌های آینده پس از کسر تعداد تخت رزرو شده از تعداد تخت آن مرکز نشان داده شده است',
  showAll: 'نمایش همه',
  showAllWithShift: 'نمایش همه',
  hospitalName: 'نام بیمارستان',
  empty: 'خالی',
  filled: 'بستری',
  capacity: 'ظرفیت',
  betCount: 'تعداد تخت',
  totalCapacity: 'ظرفیت روز',
  searchHospital: 'جستجو',
  'type_بیمارستان‌های آموزشی درمانی': 'دولتی',
  'type_بیمارستان‌های دانشگاهی': 'دولتی',
  'type_بیمارستان‌های خصوصی': 'خصوصی',
  'type_بیمارستان‌های خیریه': 'خیریه',
  'type_بیمارستان‌های وابسته به نهاد': 'دولتی',
  shift: 'ساعت:',
  totalAdmit: 'مجموع بستری استان',
  'extra_نور و حضرت علی اصغر(ع)': 'ویژه بیماران داخلی غیر کرونایی',
  'extra_آیت الله کاشانی': 'ویژه بیماران جراحی غیر کرونایی و تصادفی',
  extra_چمران: 'ویژه بیماران قلبی',
  extra_فارابی: 'پذیرش همزمان بیماران کرونایی و غیر کرونایی',
  'extra_شهید بهشتی': 'ویژه بیماران زنان و زایمان غیر کرونایی',
  extra_فیض: 'ویژه بیماری‌های چشم',
  'extra_امام موسی کاظم(ع)': 'ویژه بیماران سوختگی',
  extra_مدرس: 'ویژه بیماران روان پزشکی',
  extra_مهرگان: 'ویژه بیماران زنان و زایمان غیر کرونایی',
  'extra_سیدالشهدا(ع)': 'ویژه بیماران خون و سرطان',
  more: 'بیشتر',
};
